'use client'

import { StepperTiersModule } from 'space-mango-likes-you/components/StepperTiersModule/StepperTiersModule'
import { useStatusModule } from 'space-mango-likes-you/hooks/useStatusModule'
import { useUserDetails } from 'user-data/hooks/useUserDetails'

import styles from './MlyTiers.module.scss'

export const MlyTiers = () => {
	const userDetails = useUserDetails()
	const { annualNetExpense, progressBarMax, progressBarSteps, totalLikes } =
		useStatusModule({ userDetails })

	const tier = userDetails?.loyalty?.likes?.tier?.tier

	return (
		tier && (
			<StepperTiersModule
				className={styles.container}
				annualNetExpense={annualNetExpense}
				progressBarMax={progressBarMax}
				progressBarSteps={progressBarSteps}
				totalLikes={totalLikes}
			/>
		)
	)
}
